import React, { useEffect, useState } from 'react';
import { Toaster } from 'react-hot-toast';

import Mainroute from './routes/Mainroute';
import { useUserContext } from './context/userContext';
import { getProfileApi, getUserLanguageApi } from './utils/ApiEndpointFunctions';
import { removeToken, setLanguage } from './utils/HelperFuncitons';
import { clearCacheData } from './utils/HelperFuncitons';
import MobileAppUpdates from './pages/admin/MobileAppUpdates';

function UserApp() {
  const token = localStorage.getItem("token")
  const { userDetails,setUserDetails,setLangPreference } = useUserContext();
  const [profileError, setProfileError] = useState(false);

  const getUserDetails = async () => {
    setProfileError(false);
    try {
      const res = await getProfileApi();
      if (res.status === 200) {
        setUserDetails(res?.data.data)
        setLanguage(res?.data?.data?.language)
      } else {
        removeToken();
      }
    } catch (error) {
      setProfileError(true);
    }
  }

  const getUserLanguagePreference = async () => {
    try {
      const { data } = await getUserLanguageApi();
      if (data && data.data) {
        setLangPreference(data.data)
      }
    } catch (error) {
      console.log("languagePreference error",error);
      
    }
  }

  useEffect(() => {
    if (token) {
      clearCacheData()
      getUserDetails()
      getUserLanguagePreference()
    }
  }, [token])


  if (token && !userDetails?._id) return <div className="p-4" role="status">
    {profileError ? <><p>Unable to load your account.</p><button onClick={getUserDetails}>Retry</button> <button onClick={() => { removeToken(); window.location.assign("/"); }}>Logout</button></> : "Loading..."}
  </div>;

  return (
    <div className="App">
      <Mainroute />
      <Toaster
        position="top-right"
        reverseOrder={false}
      />
    </div>
  );
}

export default function App() {
  // Management access must not depend on a logged-in user's site/profile requests.
  return window.location.pathname.replace(/\/$/, '') === '/app-updates'
    ? <MobileAppUpdates /> : <UserApp />;
}
